import type { SlideCuepoint } from '../../viewer/components/slide-preview';

import { classNames } from '@movingimage-evp/mi-ui-component-library';
import { useLocation } from 'react-router';

import { useAbsoluteRoutes } from '../../routes';

import styles from '../dev-tools.module.css';

export type ViewerControls = {
  headerButtonsVisible: boolean;
  mockedSlide: SlideCuepoint | undefined;
  speakerHighlighted: boolean;
};

type Props = {
  value: ViewerControls;
  onChange: (name: keyof ViewerControls, value: ViewerControls[keyof ViewerControls]) => void;
};

export function MockedViewerControls({ value, onChange }: Props) {
  const { pathname } = useLocation();
  const { viewer, branding } = useAbsoluteRoutes();

  const mockedSlideCuepoint: SlideCuepoint = {
    webcastId: '',
    index: 1,
    groupId: '1',
    language: '',
  };

  if (!pathname.startsWith(viewer) && !pathname.endsWith(branding)) return null;

  return (
    <div className={styles.moduleWrapper}>
      <span>Viewer controls</span>

      <button
        className={classNames(value.headerButtonsVisible && styles.active)}
        onClick={() => onChange('headerButtonsVisible', !value.headerButtonsVisible)}
      >
        Header buttons visible
      </button>

      <button
        className={classNames(value.mockedSlide && styles.active)}
        onClick={() => onChange('mockedSlide', value.mockedSlide ? undefined : mockedSlideCuepoint)}
      >
        Slide visible
      </button>

      <button
        className={classNames(value.speakerHighlighted && styles.active)}
        onClick={() => onChange('speakerHighlighted', !value.speakerHighlighted)}
      >
        Speaker highlighted
      </button>
    </div>
  );
}
